import type { InputHTMLAttributes } from "react";

export interface CheckboxFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

/** A labelled checkbox — the boolean/toggle form vocabulary (e.g. selecting authorities). */
export function CheckboxField({ label, ...rest }: CheckboxFieldProps) {
  return (
    <label className="fui-checkbox">
      <input type="checkbox" className="fui-checkbox__input" {...rest} />
      <span className="fui-checkbox__label">{label}</span>
    </label>
  );
}
